import type { AcademicoDashboard } from '@/domain/model/AcademicoDashboard';
import type { GetAcademicoDashboardUseCase } from '@/application/port/in/GetAcademicoDashboardUseCase';
import type { AcademicoDashboardGateway } from '@/application/port/out/AcademicoDashboardGateway';

export class GetAcademicoDashboard implements GetAcademicoDashboardUseCase {
  constructor(private readonly gateway: AcademicoDashboardGateway) {}
  execute(): Promise<AcademicoDashboard> {
    return this.gateway.fetch();
  }
}
